import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  load(event) {
    event.preventDefault();

    var $link = $(event.currentTarget);
    var url = $link.attr("href");

    $link.text("Loading...").addClass("disabled").css("pointer-events", "none");

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        $(".js-load-more-results").remove();
        $("#js-show-more-results").append(html);

        $('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        onmount();
      })
      .catch(function () {
        window.notyf.error("Something went wrong when loading your request. Please try again.");
      });
  }
}
